"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const actions_1 = require("./actions");
const initialState = {
    toastNotificationsQueue: [],
};
const toastNotificationsQueue = (state = initialState.toastNotificationsQueue, action) => {
    switch (action.type) {
        case actions_1.NotificationsActionTypes.ADD_TOAST_TO_QUEUE:
            return [...state, action.payload];
        case actions_1.NotificationsActionTypes.HIDE_TOAST:
            return state.filter((toast) => toast.id !== action.payload?.id);
        case actions_1.NotificationsActionTypes.RESET_WHOLE_STORE:
            return initialState.toastNotificationsQueue;
        default:
            return state;
    }
};
exports.default = (0, redux_1.combineReducers)({
    toastNotificationsQueue,
});
